import { nanoid } from 'nanoid'

export function newSubmissionId(): string {
  return `submission-${nanoid()}`
}

export function newDraftSessionId(): string {
  return `draft-${nanoid()}`
}

export function newToastId(): string {
  return nanoid()
}

export function newConsoleEntryId(): string {
  return nanoid()
}
